import { query_to_url, urlParam } from '@/plugins/getUrlParam'

// export const query_to_url = (object = {}, encode = false) => {
//   const list = [];
//   for (const key in object) {
//     if (Object.hasOwnProperty.call(object, key)) {
//       const element = object[key];
//       if (element != undefined) {
//         list.push(`${key}=${encode ? encodeURIComponent(element) : element}`);
//       }
//     }
//   }

//   const str = list.join("&");
//   return str;
// };

/*******
 * @description: 科进医疗安全管控平台
 * @param {*} options -
 * @param {*} extraParams -
 * @return {*}
 */
export function defaultFormat (webData) {
  const {
    /*******
     * @description: 额外参数，通常是某些系统需要固定的系统id之类的
     * @return {*}
     */
    extraParams = {},
    /*******
     * @description: 参数名转换，对所有参数操作，format的最后一步
     * @return {*}
     */
    paramsMap = {},
    /*******
     * @description: 原始URL中的参数，哪些是必要的，就算空值也会传，避免三方系统错误；为空则全给（不建议，太长了）
     * @return {*}
     */
    usedUrlParamNameList = []
  } = webData

  const originUrlParam = { ...(urlParam || {}) }
  let formatUrlParam = {}
  // 非空数组则有啥给啥，否则全给
  if (usedUrlParamNameList.length) {
    usedUrlParamNameList.forEach((key) => {
      // 不判断是否为空，万一有的系统没做参数为空时给默认值，
      // requiredUrlParamName里有的不管有没有值，参数都给
      formatUrlParam[key] = originUrlParam[key] || ''
    })
  } else {
    formatUrlParam = originUrlParam
  }

  console.warn(
    '🚀 ~ file: formatWebParams.js:56 ~ defaultFormat ~ formatUrlParam== ',
    formatUrlParam,
    usedUrlParamNameList
  )
  const resultParamsObj = {
    ...formatUrlParam,
    ...extraParams
  }
  for (const key in paramsMap) {
    if (Object.hasOwnProperty.call(paramsMap, key)) {
      const value = paramsMap[key]
      // 不做判断，为空也传
      // if (resultParamsObj[key]) {
      resultParamsObj[value] = resultParamsObj[key] || ''
      delete resultParamsObj[key]
      // }
    }
  }
  return query_to_url(resultParamsObj)
}

/*******
 * @description: 病案质控
 * @param {*} webData -
 * @param {*} extraParams -
 * @return {*}
 */
// export function bazk(webData, extraParams = {}) {
//   return "userCode=-2&singleCode=frameIndex&loginKey=userID&compNo=CF148";
// }

export default {
  defaultFormat
  // bazk
}
